import { Text } from "slate";
import { BaseEditor, Editor, Transforms } from "slate";
import { ReactEditor } from "slate-react";
import { CustomText } from "../slate";

export interface FormatsEditor extends BaseEditor {
  isBold: () => boolean;
  isItalic: () => boolean;
  isUnderline: () => boolean;
  toggleBold: () => void;
  toggleItalic: () => void;
  toggleUnderline: () => void;
}
const isBold = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomText | any) => n.bold === true,
    universal: true,
  });
  return !!match;
};

const toggleBold = (editor: Editor) => {
  const isActive = isBold(editor);
  Transforms.setNodes(
    editor,
    { bold: isActive ? undefined : true },
    { match: (n) => Text.isText(n), split: true }
  );
  ReactEditor.focus(editor);
};

const isItalic = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomText | any) => n.italic === true,
    universal: true,
  });
  return !!match;
};

const toggleItalic = (editor: Editor) => {
  const isActive = isItalic(editor);
  Transforms.setNodes(
    editor,
    { italic: isActive ? undefined : true },
    { match: (n) => Text.isText(n), split: true }
  );
  ReactEditor.focus(editor);
};

const isUnderline = (editor: Editor) => {
  const [match] = Editor.nodes(editor, {
    match: (n: CustomText | any) => n.underline === true,
    universal: true,
  });
  return !!match;
};

const toggleUnderline = (editor: Editor) => {
  const isActive = isUnderline(editor);
  Transforms.setNodes(
    editor,
    { underline: isActive ? undefined : true },
    { match: (n) => Text.isText(n), split: true }
  );
  ReactEditor.focus(editor);
};

export const withFormats = (editor: Editor) => {
  editor.isBold = () => isBold(editor);
  editor.isItalic = () => isItalic(editor);
  editor.isUnderline = () => isUnderline(editor);
  editor.toggleBold = () => toggleBold(editor);
  editor.toggleItalic = () => toggleItalic(editor);
  editor.toggleUnderline = () => toggleUnderline(editor);
  return editor;
};
